<template>
  <div>
    <div class="email-form">
      <form id="email-form" @submit="sendEmail">
        <input type="email" class="user-email" id="useremail"
               name="useremail" placeholder="Twój e-mail" />
        <button type="submit" class="send btn btn-primary">Wyślij wyniki</button>
      </form>
      <div class="message-error d-none">Pole e-mail nie może być puste!</div>
      <div class="message-success d-none">Wiadomość wysłano poprawnie.</div>
    </div>
  </div>
</template>

<script>
import Home from '@/views/Home';
export default {
  name: 'SendEmail',
  props: ['targetTemplate'],
  methods: {
    sendEmail(event) {
      event.preventDefault();
      const useremail = document.querySelector('#useremail').value;

      if (!useremail) {
        const warning = document.querySelector('.message-error');
        warning.classList.remove('d-none');
        return;
      }
      this.$http
        .get(`${window.Quiz.mailerUrl}?template=${this.targetTemplate}&mailto=${useremail}`)
        .then((response) => {
          const msgSuccess = document.querySelector('.message-success');
          msgSuccess.classList.remove('d-none');
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
  #email-form {
    display: flex;
  }
  .user-email {
    border: none;
    background: #eee;
    padding: 10px 15px;
    width: 500px;
    max-width: 100%;
    height: 50px;
    display: inline-block;
    border-radius: 500px 0 0 500px;
  }
  .send {
    height: 50px;
    border: none;
    display: inline-block;
    padding-left: 1.5em;
    padding-right: 1.5em;
    margin-bottom:1em;
    border-radius: 0 500px 500px 0;
    background: var(--color-project-primary);
    color: #FFF;
  }
  .send:hover {
    background: var(--color-project-text);
    color: #FFF;
  }
  .message-success {
    width:100%;
    color: forestgreen;
  }
  .message-error {
    width:100%;
    color: crimson;
  }
</style>
